// Count endpoints return either a bare number or an object/array wrapping one
// (e.g. `5`, `"5"`, `{ count: 5 }`, `[{ patient_count: 5 }]`). Normalize to a number.
export function extractCount(data: any): number {
  if (data === null || data === undefined) return 0;
  if (typeof data === 'number') return data;
  if (typeof data === 'string') {
    const trimmed = data.trim();
    if (trimmed === '') return 0;
    const parsed = Number(trimmed);
    if (!isNaN(parsed)) return parsed;
    try {
      return extractCount(JSON.parse(trimmed));
    } catch {
      return 0;
    }
  }
  if (Array.isArray(data)) return data.length ? extractCount(data[0]) : 0;
  if (typeof data === 'object') {
    if ('count' in data) return extractCount(data.count);
    if ('data' in data) return extractCount(data.data);
    const numeric = Object.values(data).find(
      (v) => typeof v === 'number' || (typeof v === 'string' && v.trim() !== '' && !isNaN(Number(v))),
    );
    return numeric !== undefined ? Number(numeric) : 0;
  }
  return 0;
}
